
export const routerPC = [{
  path: '/',
  redirect: '',
  component: () =>
    import('../../views/Layout/MainLayout.vue'),
    children: [{
      path: '',
      name: 'home',
      component: () =>
        import('../../views/About.vue'),
        hidden: true,
      meta: {
        nav: 'home'
      }
    },
    {
      path: "/About",
      name: "about",
      component: () => import("../../views/About.vue"),
      meta: {
        nav: 'about'
      }
    },
    {
        path: "/ProductCategory/:id",
        name: "product_category",
        component: () => import("../../views/ProductCategory.vue"),
        meta: {
          nav: 'product_category'
        }
      },
      {
        path: "/Product/:id",
        name: "product",
        component: () => import("../../views/Product.vue"),
        meta: {
          nav: 'product'
        }
      },
      {
            path: "/ProductDetail/:id",
            name: "productdetail",
            component: () => import("../../views/ProductDetail.vue"),
            meta: {
              nav: 'product'
            }
          },
          {
            path: "/Esg",
            name: "esg",
            component: () => import("../../views/Esg.vue"),
            meta: {
              nav: 'esg'
            }
          },
          {
            path: "/News",
            name: "news",
            component: () => import("../../views/News.vue"),
            meta: {
              nav: 'news'
            }
          },
          {
            path: "/NewsDetail",
            name: "newsdetail",
            component: () => import("../../views/NewsDetail.vue"),
            meta: {
              nav: 'news'
            }
          },
          {
            path: "/Join",
            name: "join",
            component: () => import("../../views/Join.vue"),
            meta: {
              nav: 'join'
            }
          },
          {
            path: "/JoinDetail/:id",
            name: "joindetail",
            component: () => import("../../views/JoinDetail.vue"),
            meta: {
              nav: 'join'
            }
          },
          {
            path: "/Contact",
            name: "contact",
            component: () => import("../../views/Contact.vue"),
            meta: {
              nav: 'contact'
            }
          },
  ]
},

]


// const routes = [
//   {
//     path: "/",
//     component: () => import("../views/Layout/MainLayout.vue"),
//     children: [
//       {
//         path: "",
//         name: "home",
//         component: () => import("../views/About.vue"),
//         meta: {
//           nav: 'home'
//         }
//       },
//       {
//         path: "/About",
//         name: "about",
//         component: () => import("../views/About.vue"),
//         meta: {
//           nav: 'about'
//         }
//       },
//       {
//         path: "/ProductCategory/:id",
//         name: "product_category",
//         component: () => import("../views/ProductCategory.vue"),
//         meta: {
//           nav: 'product_category'
//         }
//       },
//       {
//         path: "/Product/:id",
//         name: "product",
//         component: () => import("../views/Product.vue"),
//         meta: {
//           nav: 'product'
//         }
//       },
//       {
//         path: "/ProductDetail/:id",
//         name: "productdetail",
//         component: () => import("../views/ProductDetail.vue"),
//         meta: {
//           nav: 'product'
//         }
//       },
//       {
//         path: "/Esg",
//         name: "esg",
//         component: () => import("../views/Esg.vue"),
//         meta: {
//           nav: 'esg'
//         }
//       },
//       {
//         path: "/News",
//         name: "news",
//         component: () => import("../views/News.vue"),
//         meta: {
//           nav: 'news'
//         }
//       },
//       {
//         path: "/NewsDetail",
//         name: "newsdetail",
//         component: () => import("../views/NewsDetail.vue"),
//         meta: {
//           nav: 'news'
//         }
//       },
//       {
//         path: "/Join",
//         name: "join",
//         component: () => import("../views/Join.vue"),
//         meta: {
//           nav: 'join'
//         }
//       },
//       {
//         path: "/JoinDetail/:id",
//         name: "joindetail",
//         component: () => import("../views/JoinDetail.vue"),
//         meta: {
//           nav: 'join'
//         }
//       },
//       {
//         path: "/Contact",
//         name: "contact",
//         component: () => import("../views/Contact.vue"),
//         meta: {
//           nav: 'contact'
//         }
//       },
     
//     ],
//   },
// ];

